(function () {
  if (window.cardSwatchesReady) return;
  window.cardSwatchesReady = true;

  function getPreview(card) {
    var mask = card.querySelector('.grid-product__image-mask');
    if (!mask) return null;

    var preview = mask.querySelector('.card-swatch-preview');
    if (!preview) {
      var mainImage = mask.querySelector('img');
      preview = document.createElement('img');
      preview.className = 'card-swatch-preview';
      preview.alt = '';
      if (mainImage) preview.style.objectFit = window.getComputedStyle(mainImage).objectFit;
      mask.appendChild(preview);
    }
    return preview;
  }

  function show(card, src) {
    var preview = getPreview(card);
    if (!preview) return;
    if (!src) {
      preview.classList.remove('is-visible');
      return;
    }
    if (preview.getAttribute('src') !== src) preview.setAttribute('src', src);
    preview.classList.add('is-visible');
  }

  document.addEventListener('mouseover', function (event) {
    var swatch = event.target.closest('[data-card-swatch]');
    if (!swatch || !swatch.dataset.swatchImage) return;
    var row = swatch.closest('[data-card-swatches]');
    if (!row || !row.hasAttribute('data-hover-image')) return;
    var card = swatch.closest('.grid-product');
    if (card) show(card, swatch.dataset.swatchImage);
  });

  document.addEventListener('mouseout', function (event) {
    var row = event.target.closest('[data-card-swatches]');
    if (!row || row.contains(event.relatedTarget)) return;
    if (!row.hasAttribute('data-hover-image')) return;
    var card = row.closest('.grid-product');
    if (card) show(card, card.dataset.swatchSelected || '');
  });

  document.addEventListener('click', function (event) {
    var swatch = event.target.closest('[data-card-swatch]');
    if (!swatch) return;
    var card = swatch.closest('.grid-product');
    if (!card) return;
    event.preventDefault();

    card.querySelectorAll('[data-card-swatch].is-active').forEach(function (el) {
      el.classList.remove('is-active');
    });
    swatch.classList.add('is-active');

    card.dataset.swatchSelected = swatch.dataset.swatchImage || '';
    show(card, card.dataset.swatchSelected);

    var link = card.querySelector('.grid-product__link');
    if (link) link.setAttribute('href', swatch.getAttribute('href'));
  });
})();
